<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">
        {{ viewClientInfo.clientName }} {{ viewClientInfo.clientLastName }} -
        {{ viewClientInfo.clientEmail }}
      </h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeViewClientDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text style="min-height: 450px;" class="no-padding">
      <div class="client-datatable header clear">
        <div class="col-one"></div>
        <div class="col-two">Datum verzonden</div>
        <div class="col-three">Beantwoord</div>
        <div class="col-four">Score</div>
        <div class="col-five">Salon</div>
        <div class="col-six">Geholpen door</div>
        <div class="col-seven"></div>
      </div>
      <div v-if="clientDataLoaded == false">
        <div class="loading-dots">
          <div class="loading-dots-loader"></div>
        </div>
      </div>

      <div v-if="clientDataLoaded == true">
        <div v-for="survey in clientSurveys" :key="survey.id">
          <div class="client-datatable custom-row clear">
            <div class="col-one">
              <v-icon
                :color="$vuetify.theme.themes[theme].text"
                v-if="survey.expanded == false"
                @click="closeSurveyData(survey), loadSurveyData(survey)"
                >arrow_right</v-icon
              >
              <v-icon
                :color="$vuetify.theme.themes[theme].text"
                v-if="survey.expanded == true"
                @click="(survey.expanded = false), loadSurveyData(survey)"
              >
                arrow_drop_down</v-icon
              >
            </div>
            <div class="col-two">
              {{ survey.dateSend.seconds | moment("D MMMM YYYY") }}
            </div>
            <div class="col-three">
              <span v-if="survey.ratingSummary">
                {{ survey.ratingSummary.length }} / {{ survey.ratingItems }}
              </span>
              <span v-else> 0 / {{ survey.ratingItems }} </span>
            </div>
            <div class="col-four">
              <span v-if="survey.ratingSummary.length > 0">
                <span
                  class="client-data-smiley block"
                  v-bind:class="
                    'score-' +
                      Math.round(
                        survey.ratingSummary.reduce((a, b) => a + b, 0) /
                          survey.ratingSummary.length,
                      )
                  "
                ></span>
                <span class="client-data-score">{{
                  (
                    (survey.ratingSummary.reduce((a, b) => a + b, 0) /
                      survey.ratingSummary.length) *
                    2
                  ).toFixed(1)
                }}</span>
              </span>
            </div>
            <div class="col-four">
              <span v-for="branch in branches" :key="branch.id">
                <span v-if="branch.id == survey.branchId">{{
                  branch.branchName
                }}</span>
              </span>
            </div>
            <div class="col-six">
              <span>{{ survey.clientLastTreatmentByName }}</span>
            </div>
            <div class="col-seven text-right">
              <v-icon
                small
                class="mx-1"
                color="text"
                v-if="survey.manualCompanyAnswered"
                >headset_mic</v-icon
              >
              <v-btn
                v-if="userRole == 'admin' || userRole == 'superadmin'"
                @click="editSurveyData(survey.id)"
                text
                icon
              >
                <v-icon small class="mx-1" color="text">edit</v-icon>
              </v-btn>
            </div>
          </div>

          <div v-if="survey.expanded == true">
            <div
              class="client-datatable expanded-row clear"
              v-for="(surveyQuestion, index) in surveyQuestions"
              :key="index"
            >
              <div class="col-one"></div>
              <div class="col-two">
                {{ surveyQuestion.question[survey.clientLanguage] }}
              </div>
              <div class="col-three">
                <span
                  class="client-data-no-result"
                  v-if="
                    surveyQuestion.type == 'rating' && !surveyQuestion.rating
                  "
                  >Geen beoordeling</span
                >
                <span
                  class="client-data-no-result"
                  v-if="
                    surveyQuestion.type == 'feedback' &&
                      !surveyQuestion.feedback
                  "
                  >Geen feedback</span
                >
                <span v-if="surveyQuestion.feedback">{{
                  surveyQuestion.feedback
                }}</span>
                <span v-if="surveyQuestion.rating">
                  <div
                    class="client-data-smiley block"
                    v-bind:class="'score-' + surveyQuestion.rating"
                  ></div>
                  <div class="client-data-score" v-if="surveyQuestion.rating">
                    {{ (surveyQuestion.rating * 2).toFixed(1) }}
                  </div>
                </span>
              </div>
              <div class="col-four">
                <span v-if="surveyQuestion.dateUpdated"
                  >{{
                    surveyQuestion.dateUpdated.seconds
                      | moment("D-MM-YYYY - HH:mm")
                  }}u</span
                >
              </div>

              <div class="col-five"></div>
              <div class="col-six"></div>
              <div class="col-seven"></div>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>

    <edit-survey-data
      :activeCompData="activeCompData"
      :type="'clients'"
    ></edit-survey-data>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import EditSurveyData from "../modals/EditSurveyData.vue";
import { bus } from "../../main";

export default {
  name: "client-data-modal",
  props: [
    "viewClientInfo",
    "clientSurveys",
    "branches",
    "clientDataLoaded",
    "activeCompData",
  ],
  components: {
    "edit-survey-data": EditSurveyData,
  },
  data() {
    return {
      surveyQuestions: [],
      clientSurveyData: [],
      pagination: {
        rowsPerPage: "10",
        sortBy: "dateSend.seconds",
        descending: true,
      },
    };
  },

  methods: {
    loadSurveyData(survey) {
      this.surveyQuestions = survey.surveyQuestions;
    },

    viewClient(item) {
      this.viewClientDialog = true;
      this.editedIndex = this.clients.indexOf(item);
      this.viewClientInfo = Object.assign({}, item);
      this.loadClientData();
    },

    closeSurveyData(survey) {
      this.clientSurveys.forEach((surveyItem) => {
        surveyItem.expanded = false;
      });
      survey.expanded = true;
    },

    closeViewClientDialog() {
      this.clientSurveys.forEach((surveyItem) => {
        surveyItem.expanded = false;
      });
      this.$emit("closeClientViewDialogChange");
      this.clientSurveyData = [];
    },

    editSurveyData(id) {
      bus.$emit("getJourneyData", id);
    },
  },

  computed: {
    pages() {
      if (this.clientSurveys.length > 0) {
        return Math.ceil(
          this.clientSurveys.length / this.pagination.rowsPerPage,
        );
      }
    },
    userRole() {
      return this.$store.state.userRole;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>
<style>
.v-card__text.no-padding {
  padding: 0 !important;
}

.client-data-smiley {
  width: 26px;
  height: 26px;
  display: inline-block;
}

.client-data-smiley.block {
  display: block;
  float: left;
}

.client-data-score {
  float: left;
  height: 26px;
  line-height: 26px;
  padding: 0 5px;
  display: block;
  color: #8b93a6;
}

.client-data-smiley.score-1 {
  background: url("../../assets/icons/rating/smiley-score-1.svg") no-repeat
    center center;
  background-size: 26px;
}

.client-data-smiley.score-2 {
  background: url("../../assets/icons/rating/smiley-score-2.svg") no-repeat
    center center;
  background-size: 26px;
}

.client-data-smiley.score-3 {
  background: url("../../assets/icons/rating/smiley-score-3.svg") no-repeat
    center center;
  background-size: 26px;
}

.client-data-smiley.score-4 {
  background: url("../../assets/icons/rating/smiley-score-4.svg") no-repeat
    center center;
  background-size: 26px;
}

.client-data-smiley.score-5 {
  background: url("../../assets/icons/rating/smiley-score-5.svg") no-repeat
    center center;
  background-size: 26px;
}

.client-datatable div,
.client-datatable span {
  color: var(--v-text-base) !important;
  font-size: 13px;
}

.client-datatable.header {
  padding: 15px 0 10px 0;
  background-color: var(--v-background-base);
  border-bottom: 1px solid var(--v-menuborder-base);
}

.client-datatable.custom-row {
  padding: 15px 0 10px 0;
  background-color: var(--v-menu-base);
  border-bottom: 1px solid var(--v-menuborder-base);
}

.client-datatable.expanded-row {
  background-color: var(--v-background-base);
  padding: 8px 0;
  min-height: 40px;
  border-bottom: 1px solid var(--v-menuborder-base);
}

.client-datatable .col-one {
  width: 5%;
  float: left;
  padding: 0 10px;
  min-height: 1px;
}

.client-datatable .col-two {
  width: 20%;
  float: left;
  min-height: 1px;
  padding: 0 5px;
}

.client-datatable .col-three {
  width: 20%;
  float: left;
  min-height: 1px;
  padding: 0 5px;
}

.client-datatable .col-four {
  width: 15%;
  float: left;
  min-height: 1px;
  padding: 0 5px;
}

.client-datatable .col-five {
  width: 15%;
  float: left;
  min-height: 1px;
  padding: 0 5px;
}

.client-datatable .col-six {
  width: 15%;
  float: left;
  min-height: 1px;
  padding: 0 5px;
}
.client-datatable .col-seven {
  width: 10%;
  float: left;
  min-height: 1px;
  padding: 0 5px;
}

.client-datatable.expanded-row .col-one {
  width: 5%;
}

.client-datatable.expanded-row .col-two {
  width: 40%;
  padding: 4px 5px;
}

.client-datatable.expanded-row .col-three {
  width: 30%;
  padding: 4px 15px 4px 5px;
}

.client-datatable.expanded-row .col-four {
  width: 20%;
  text-align: left;
  padding: 4px 15px 4px 5px;
}

.client-datatable span.client-data-no-result {
  color: rgba(139, 147, 166, 0.4) !important;
}
</style>
